import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatInput = ({ onSendMessage, onTyping, currentLanguage }) => {
  const [message, setMessage] = useState('');
  const [showAttachmentMenu, setShowAttachmentMenu] = useState(false);

  const translations = {
    en: {
      typeMessage: 'Type your message...',
      send: 'Send',
      attachFile: 'Attach File',
      attachImage: 'Attach Image',
      attachDocument: 'Attach Document'
    },
    ko: {
      typeMessage: '메시지를 입력하세요...',
      send: '보내기',
      attachFile: '파일 첨부',
      attachImage: '이미지 첨부',
      attachDocument: '문서 첨부'
    }
  };

  const t = translations?.[currentLanguage];

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (message?.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSubmit(e);
    }
  };

  const handleChange = (e) => {
    setMessage(e?.target?.value);
    if (onTyping) {
      onTyping();
    }
  };

  return (
    <div className="relative">
      <form onSubmit={handleSubmit} className="flex items-end gap-2 md:gap-3">
        <div className="relative flex-1">
          <textarea
            value={message}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder={t?.typeMessage}
            rows={1}
            className="w-full px-4 py-3 md:px-5 md:py-4 pr-12 md:pr-14 bg-muted border border-border rounded-xl text-sm md:text-base text-foreground placeholder:text-muted-foreground resize-none focus:outline-none focus:ring-2 focus:ring-primary transition-base"
            style={{ minHeight: '48px', maxHeight: '120px' }}
          />
          
          <button
            type="button"
            onClick={() => setShowAttachmentMenu(!showAttachmentMenu)}
            className="absolute right-3 bottom-3 md:right-4 md:bottom-4 p-2 hover:bg-background/50 rounded-lg transition-base"
          >
            <Icon name="Paperclip" size={20} color="var(--color-muted-foreground)" />
          </button>

          {showAttachmentMenu && (
            <div className="absolute right-0 bottom-full mb-2 bg-card border border-border rounded-lg shadow-elevation-lg overflow-hidden z-10">
              <button
                type="button"
                className="flex items-center gap-3 w-full px-4 py-3 hover:bg-muted transition-base text-left"
                onClick={() => setShowAttachmentMenu(false)}
              >
                <Icon name="Image" size={18} color="var(--color-primary)" />
                <span className="text-sm md:text-base text-foreground whitespace-nowrap">
                  {t?.attachImage}
                </span>
              </button>
              <button
                type="button"
                className="flex items-center gap-3 w-full px-4 py-3 hover:bg-muted transition-base text-left"
                onClick={() => setShowAttachmentMenu(false)}
              >
                <Icon name="FileText" size={18} color="var(--color-secondary)" />
                <span className="text-sm md:text-base text-foreground whitespace-nowrap">
                  {t?.attachDocument}
                </span>
              </button>
            </div>
          )}
        </div>

        <Button
          type="submit"
          variant="default"
          size="lg"
          iconName="Send"
          iconPosition="right"
          disabled={!message?.trim()}
          className="flex-shrink-0"
        >
          <span className="hidden md:inline">{t?.send}</span>
        </Button>
      </form>
    </div>
  );
};

export default ChatInput;